// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
export const fermentationParameterLegacyArchiveId = (z.number());
export const fermentationParameterLegacyArchive = z.object({
    id: fermentationParameterLegacyArchiveId,
    unit: z.string().nullable(),
    ramp_from: z.string().nullable(),
    protocol_application_id: z.number().nullable(),
    source_type: z.string().nullable(),
});
export const fermentationParameterLegacyArchiveInitializer = z.object({
    id: fermentationParameterLegacyArchiveId,
    unit: z.string().optional().nullable(),
    ramp_from: z.string().optional().nullable(),
    protocol_application_id: z.number().optional().nullable(),
    source_type: z.string().optional().nullable(),
});
export const fermentationParameterLegacyArchiveMutator = z.object({
    id: fermentationParameterLegacyArchiveId.optional(),
    unit: z.string().optional().nullable(),
    ramp_from: z.string().optional().nullable(),
    protocol_application_id: z.number().optional().nullable(),
    source_type: z.string().optional().nullable(),
});
//# sourceMappingURL=FermentationParameterLegacyArchive.js.map